import React, { Component } from 'react'
import PropTypes from 'prop-types'
import FormEntry from '../../../models/FormEntry'
import { FormTextArea } from 'semantic-ui-react'
import { observer } from 'mobx-react'

@observer
class TextArea extends Component {
  static propTypes = {
    ...FormTextArea.propTypes,
    formEntry: PropTypes.instanceOf(FormEntry),
    castValue: PropTypes.func,
    name: PropTypes.string.isRequired,
    label: PropTypes.string,
    isFixed: PropTypes.bool,
    isRequired: PropTypes.bool
  }

  static defaultProps = {
    isFixed: false,
    isRequired: false
  }

  handleOnChangeInput = e => {
    const { formEntry, castValue, isFixed } = this.props
    const value = castValue ? castValue(e.target.value) : e.target.value
    formEntry.updateValue(e.target.name, value, isFixed)
  }

  render () {
    const {
      formEntry,
      defaultValue,
      name,
      options,
      onChange,
      castValue,
      parseValue,
      errorPointing,
      error,
      isFixed,
      isRequired,
      ...props
    } = this.props
    const value = formEntry.getValue(name, isFixed)
    if (formEntry.readonly) {
      return <div className='field'><label>{this.props.label}</label><p>{value}</p></div>
    }
    return (
      <FormTextArea
        value={parseValue ? parseValue(value) : value}
        name={name}
        onChange={onChange || this.handleOnChangeInput}
        {...props}
      />
    )
  }
}

export default TextArea
